export const AUTH_STORAGE_KEY = 'ai_stone_access_token'
// Токен имперсонации живёт в sessionStorage: вкладка изолирована, собственная
// сессия суперадмина в localStorage не затирается, закрытие вкладки её заканчивает.
export const IMPERSONATION_STORAGE_KEY = 'ai_stone_impersonation_token'

export function setAuthToken(token: string | null): void {
  if (!token) {
    localStorage.removeItem(AUTH_STORAGE_KEY)
    sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY)
    return
  }

  localStorage.setItem(AUTH_STORAGE_KEY, token)
}

export function setImpersonationToken(token: string): void {
  sessionStorage.setItem(IMPERSONATION_STORAGE_KEY, token)
}

export function clearImpersonationToken(): void {
  sessionStorage.removeItem(IMPERSONATION_STORAGE_KEY)
}

export function getAuthToken(): string | null {
  return sessionStorage.getItem(IMPERSONATION_STORAGE_KEY) ?? localStorage.getItem(AUTH_STORAGE_KEY)
}
